import styled from 'styled-components';

interface IContainerProps {
  height?: any;
}

export const Container = styled.div<IContainerProps>`
    display: flex;
    flex-direction: column;
    width: 100vw;
    max-width: 100vw;
    height: ${props => props.height || '100vh'};
    max-height: ${props => props.height || '100vh'};
`

interface IContentProps {
  height?: string;
  backgroundColor?: string;
}

export const Content = styled.div<IContentProps>`
    height: ${props => props.height || 'auto'};
    background-color: ${props => props.backgroundColor || 'transparent'};
    max-width: 100vw;
`

interface IContentBodyProps {
  fullHeight?: boolean;
  displayFlex?: boolean;
}

export const ContentBody = styled.div<IContentBodyProps>`
    padding-left: 5%;
    padding-right: 5%;
    width: 100%;
    display: ${props => props.displayFlex ? 'flex' : 'block'};
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 700px) {
        padding-left: 5px;
        padding-right: 5px;
    }
`

export const SessionExpiringMessage = styled.div`
    padding: 5px;
    background-color:rgb(123, 255, 0);
    color:rgb(56, 0, 0);
    text-align: center;
    font-weight: bold;
`